import { render, staticRenderFns } from "./summaryPie.vue?vue&type=template&id=15b73979&scoped=true"
import script from "./summaryPie.vue?vue&type=script&lang=js"
export * from "./summaryPie.vue?vue&type=script&lang=js"
import style0 from "./summaryPie.vue?vue&type=style&index=0&id=15b73979&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b73979",
  null
  
)

export default component.exports